import { Link } from 'react-router-dom';

export const PncLogo = ({ size = 'sm', caption = true, linkTo = '/' }) => {
  const h = size === 'lg' ? 'h-24 sm:h-28' : size === 'md' ? 'h-14' : 'h-9';
  const body = (
    <span className="inline-flex flex-col items-center gap-2">
      <img src="/pnc-logo-white.png" alt="PNC UNIQUE LTD" className={`${h} w-auto`} />
      {caption && (
        <span className="text-[10px] uppercase tracking-[0.28em] text-[var(--muted)] font-semibold">
          Contract E-Signature Portal
        </span>
      )}
    </span>
  );
  if (!linkTo) return body;
  return (
    <Link to={linkTo} data-testid="pnc-logo-link" className="inline-flex">
      {body}
    </Link>
  );
};

export default PncLogo;
